export { ConsentManager } from './ConsentManager'
export type { ConsentManagerProps } from './types'
